// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html,
body {
  display: block;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.App {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: sans-serif;
}

form.Login {
  flex: 1 1 auto;
  display: block;
  min-width: 20rem;
  max-width: 50vw;
  margin: 0 auto;
  padding: 2rem 2rem 3rem;
  border: 1px solid #eaeaea;
  border-radius: 0.25rem;
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1),
    0 0.6rem 0.8rem rgba(0, 0, 0, 0.1);
}

form.Login > * {
  display: block;
  width: 100%;
}

form.Login h1 {
  margin: 0 0 2rem;
  padding-right: 2rem;
  line-height: 1.4;
  font-size: 1.2rem;
  font-weight: normal;
}

form.Login h1 strong {
  display: block;
  color: #1054de;
  font-size: 1.5rem;
}

form.Login label {
  margin-bottom: 0.5rem;
  padding-left: 0.1rem;
  font-weight: bold;
  text-transform: capitalize;
  word-break: none;
}

form.Login label:after {
  content: ":";
}

form.Login input {
  margin-bottom: 1.7rem;
  padding: 0.6rem 0.7rem 0.5rem;
  border: 1px solid #cacaca;
  border-radius: 0.25rem;
  font-size: 1rem;
}

form.Login button {
  margin-top: 2rem;
  padding: 0.8rem 1rem;
  border: none;
  border-radius: 0.25rem;
  background: #1054de;
  cursor: pointer;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.3s;
}

form.Login button:hover {
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB;sCACoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.App {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  font-family: sans-serif;\n}\n\nform.Login {\n  flex: 1 1 auto;\n  display: block;\n  min-width: 20rem;\n  max-width: 50vw;\n  margin: 0 auto;\n  padding: 2rem 2rem 3rem;\n  border: 1px solid #eaeaea;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1),\n    0 0.6rem 0.8rem rgba(0, 0, 0, 0.1);\n}\n\nform.Login > * {\n  display: block;\n  width: 100%;\n}\n\nform.Login h1 {\n  margin: 0 0 2rem;\n  padding-right: 2rem;\n  line-height: 1.4;\n  font-size: 1.2rem;\n  font-weight: normal;\n}\n\nform.Login h1 strong {\n  display: block;\n  color: #1054de;\n  font-size: 1.5rem;\n}\n\nform.Login label {\n  margin-bottom: 0.5rem;\n  padding-left: 0.1rem;\n  font-weight: bold;\n  text-transform: capitalize;\n  word-break: none;\n}\n\nform.Login label:after {\n  content: \":\";\n}\n\nform.Login input {\n  margin-bottom: 1.7rem;\n  padding: 0.6rem 0.7rem 0.5rem;\n  border: 1px solid #cacaca;\n  border-radius: 0.25rem;\n  font-size: 1rem;\n}\n\nform.Login button {\n  margin-top: 2rem;\n  padding: 0.8rem 1rem;\n  border: none;\n  border-radius: 0.25rem;\n  background: #1054de;\n  cursor: pointer;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: bold;\n  transition: all 0.3s;\n}\n\nform.Login button:hover {\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
